import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FEATURE_FILTERS_SECTIONS } from '@informally/frontend/filters/data/feature-filters-sections';
import { DashboardsModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/dashboards/dashboards.module';
import { DataSourceModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/data-source/data-source.module';
import { FiltersModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/filters/filters.module';
import { SmartGridModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/smart-grid/smart-grid.module';
import { TourModule } from '@suvo/frontend-framework/SUVO-BI-CLIENT-LIB/projects/suvo-bi-client-lib/src/lib/features/tour/tour.module';
import { OrganisationModule } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/organisation/modules/organisation/organisation.module';
import { SubscriptionModule } from '@suvo/frontend-framework/SUVO-USERS-CLIENT-LIB/projects/suvo-users-client-lib/src/lib/features/subscription/modules/subscription.module';
import { environment } from '../../../environments/environment';
import { SubscriptionInterceptor } from '../../shared/interceptor/subscription.interceptor';
import { SharedModule } from '../../shared/shared.module';
import { CustomerNavigationModule } from './customer-navigation/customer-navigation.module';
import { CustomerDashboardsModule } from './dashboards/customer-dashboards.module';
import { EmailAlertsModule } from './email-alerts/email-alerts.module';
import { PrivateComponent } from './private.component';
import { TourDialogComponent } from './tour-dialog/tour-dialog.component';

@NgModule({
  declarations: [PrivateComponent, TourDialogComponent],
  imports: [
    CommonModule,
    SharedModule,
    TourModule,
    DataSourceModule.forRoot({
      dataServiceApi: environment.dataServiceApi,
    }),
    OrganisationModule,
    SubscriptionModule,
    SmartGridModule,
    DashboardsModule.forRoot(environment),
    CustomerNavigationModule,
    CustomerDashboardsModule,
    EmailAlertsModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SubscriptionInterceptor,
      multi: true,
    },
  ],
})
export class PrivateModule {
  static forRoot(): ModuleWithProviders<PrivateModule> {
    let augmentedFiltersSections = FEATURE_FILTERS_SECTIONS;

    const filtersModuleConfig = FiltersModule.forRoot({
      dataServiceApi: environment.dataServiceApi,
      filtersSections: augmentedFiltersSections,
      reverseUrlParts: false,
    });

    return {
      ngModule: PrivateModule,
      providers: [...filtersModuleConfig.providers],
    };
  }
}
